import {
  CalendarDetailsVisibility,
  CalendarEventSyncState,
  CalendarSyncStates,
  ExternalConnection,
  ID,
  LinkedItemGoal,
  Task,
} from '@griply/types';

import { getTaskCalendarSyncCandidates } from './get-task-calendar-sync-candidates';

export type GetCalendarSyncStatesOptions = {
  tasks: Task[];
  connections: ExternalConnection[];
  goals: LinkedItemGoal[];
};

export const getCalendarSyncStates = ({
  tasks,
  connections,
  goals,
}: GetCalendarSyncStatesOptions): CalendarSyncStates => {
  const goalsById = new Map<ID, LinkedItemGoal>(
    goals.map((goal) => [goal.id, goal]),
  );

  return tasks.reduce<Map<ID, CalendarEventSyncState>>((map, task) => {
    const candidates = getTaskCalendarSyncCandidates({
      task,
      connections,
      goalsById,
    });
    if (!candidates.length) {
      return map;
    }

    const syncedCandidates = candidates.filter(({ synced }) => synced);
    map.set(task.id, {
      isSynced: !!syncedCandidates.length,
      isHidden:
        !!syncedCandidates.length &&
        syncedCandidates.every(
          ({ visibility }) => visibility === CalendarDetailsVisibility.Hidden,
        ),
    });
    return map;
  }, new Map());
};
